import IconSeat from "@Icons/searchRes/amenities/IconSeat";
import IconType from "@/types/Icon.type";

function IconSeatPassengerClass(props: IconType) {
    return (
        <IconSeat
            {...props}
        />
    )
}

export default IconSeatPassengerClass